export default __webpack_public_path__ + "static/media/play-icon@2x.451daac0.png";